import React, { useState } from "react";
import { DDNav } from "../../../components/Admin/DDNav/DDNav";
import { BIBLIO_TOPICS, STD_META } from "./biblioCatalog";
import "./Bibliography.scss";

export function Bibliography() {
  const [topicId, setTopicId] = useState("cer");

  const topic = BIBLIO_TOPICS.find((t) => t.id === topicId);

  return (
    <div className="bib-page">
      <DDNav />
      <div className="bib-content">
      <div className="bib-ph">
        <div>
          <h1 className="bib-title">Bibliografía y Recomendaciones por Estándar</h1>
          <div className="bib-sub">
            Matriz comparativa · OCDE · OIT · Better Work · FLA · ONU · ISO · citas textuales verificables
          </div>
        </div>
      </div>

      <div className="bib-intro-box">
        <h3>📖 Cómo usar esta matriz</h3>
        <p>
          Para cada política o procedimiento que la fábrica necesita redactar, esta vista muestra qué
          dice <b>cada estándar internacional reconocido</b> al respecto: la recomendación específica,
          la cita textual entre comillas (cuando está disponible) y la referencia bibliográfica exacta.
        </p>
        <p>
          Sirve como <b>justificación normativa</b> de cada cláusula de las plantillas del Repositorio:
          al redactar una política de Trabajo Forzoso, podés demostrar al auditor que cada compromiso
          responde a una recomendación específica de OCDE 2021, OIT C29, Better Work CAT y FLA Code,
          con la cita verbatim a mano.
        </p>
      </div>

      <div className="bib-layout">
        {/* Sidebar */}
        <div className="bib-topics">
          {BIBLIO_TOPICS.map((t, i) => (
            <button
              key={t.id}
              className={`bib-topic-btn${topicId === t.id ? " active" : ""}`}
              onClick={() => setTopicId(t.id)}
            >
              <span className="ico">{t.ico}</span>
              <span className="lbl">{t.label}</span>
              <span className="ct">{String(i + 1).padStart(2, "0")}</span>
            </button>
          ))}
        </div>

        {/* Panel */}
        {topic && (
          <div className="bib-panel">
            <div className="bib-th">
              <h2>{topic.ico} {topic.label}</h2>
              <div className="sub">{topic.sub}</div>
            </div>

            <div className="bib-std-grid">
              {topic.sources.map((src) => {
                const meta = STD_META[src.std];
                return (
                  <div key={src.std} className={`bib-std-card ${src.std}`}>
                    <div className="bib-std-hd">
                      <span className="bib-std-bn">{meta.name}</span>
                      <span className="fullname">{meta.full}</span>
                    </div>
                    <div className="bib-std-body">
                      {src.recs.map((r, i) => (
                        <div key={i} className="bib-rec">
                          <div className="bib-rec-title">
                            <span className="num">{i + 1}</span>
                            <span>{r.t}</span>
                          </div>
                          {r.q ? (
                            <div className="bib-rec-quote">
                              "{r.q}"
                              <span className="bib-rec-src">📚 {r.s}</span>
                            </div>
                          ) : (
                            <div className="bib-rec-quote no-quote">
                              <span className="bib-rec-src">📚 {r.s}</span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="bib-foot">
              <h4>📋 Cómo usar estas referencias</h4>
              <p>
                Cada cita textual entre comillas <code>"..."</code> es <b>verbatim</b> de la fuente
                original (con su artículo, párrafo y año). Las recomendaciones sin cita reflejan la
                estructura del documento referenciado.
              </p>
              <p>
                Al redactar la política de la fábrica, citá la fuente exacta en la sección "Marco
                normativo de referencia" — el auditor verifica que cada cláusula tenga su respaldo
                en al menos uno de estos estándares.
              </p>
            </div>
          </div>
        )}
      </div>
      </div>
    </div>
  );
}
